var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ServiceForm',{attrs:{"type":'edit',"save-action":_vm.updateItemAction,"back":_vm.back,"error":_vm.error,"loading":_vm.loading,"saved":_vm.updated,"item":_vm.item,"reset-action":_vm.resetAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }